// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__JWY63","paragraph":"style_paragraph__pDIhh"};